import { getCollectorOnCase } from '@debbie/common/dist/cases/index.js';
import { Entity } from '@debbie/common/dist/index.js';
import { IntentType } from '@debbie/common/dist/intents/index.js';
import { Direction, InteractionType, OutgoingState, } from '@debbie/common/dist/interactions/index.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { getMentionSuggestions } from '@debbie/common/dist/templates/suggestions.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { useEmailServer } from '@debbie/cortex/dist/email-servers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { PARSE_RESULT_TYPE, getSubjectContent, parseText, } from '../../../utils/templates.js';
import { PlaceholderLoader, Search } from '../../index.js';
import { Modal } from '../../index.js';
import { PDFTemplatePreview } from '../../interactions/PDFTemplatePreview.js';
import PreviewInteraction from '../../interactions/PreviewInteraction.js';
const PreviewModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const caseId = props.caseId;
    const tenant = useTenant();
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const mentionSuggestions = getMentionSuggestions(lang, props.template.type, propertyTypes || undefined, tenant);
    const singleCaseLoader = useCase(caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const collectorId = singleCase &&
        creditor &&
        getCollectorOnCase(singleCase.type, singleCase.collectorId, creditor.identityCollectorId, creditor.defaultCollectorId);
    const collectorLoadable = useCollector(collectorId || undefined);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const emailServerLoadable = useEmailServer(collector?.emailServerId);
    const emailServer = h.hasData(emailServerLoadable)
        ? emailServerLoadable.data
        : null;
    const newInteraction = {
        templateId: props.templateId,
        direction: Direction.OUTGOING,
        state: OutgoingState.SENT,
        attachments: [],
        referenceId: caseId,
        referenceType: Entity.Case,
        minVisibilityRole: 'client',
        intent: {
            type: IntentType.Unknown,
        },
    };
    return (React.createElement(Modal, { header: lang.templates.preview, onToggle: props.toggleModal },
        React.createElement(Search, { removeWrapper: true, entity: Entity.Case, autoFocus: true, onSelect: (result) => {
                if (result.id) {
                    props.setCaseId(result.id);
                }
            } }),
        props.template &&
            [TemplateType.LETTER, TemplateType.EBOKS].includes(props.template.type) &&
            caseId && (React.createElement(PDFTemplatePreview, { caseId: caseId, templateId: props.templateId, body: parseText(props.content, mentionSuggestions), versionId: props.template.versionId })),
        props.template &&
            props.template.type === TemplateType.EMAIL &&
            caseId &&
            (emailServer ? (React.createElement(PreviewInteraction, { versionId: props.template.versionId, interaction: {
                    ...newInteraction,
                    type: InteractionType.Email,
                    details: {
                        server: emailServer.id,
                        subject: getSubjectContent(parseText(props.subject, mentionSuggestions)),
                        from: `${emailServer.fromName} <${emailServer.fromEmail}>`,
                        body: parseText(props.content, mentionSuggestions),
                        html: parseText(props.content, mentionSuggestions),
                        to: 'info@example.com',
                        cc: null,
                        bcc: null,
                    },
                } })) : (React.createElement(PlaceholderLoader, null))),
        props.template &&
            props.template.type === TemplateType.AUTOCALL &&
            caseId && (React.createElement(PreviewInteraction, { versionId: props.template.versionId, interaction: {
                ...newInteraction,
                type: InteractionType.AutoCall,
                details: {
                    actions: props.template.details.actions,
                    transcript: parseText(props.content, mentionSuggestions, PARSE_RESULT_TYPE.TEXT),
                    voiceName: 'Mads',
                    fromCountryCode: '45',
                    fromPhoneNumber: '12345678',
                    toCountryCode: '45',
                    toPhoneNumber: '12345678',
                },
            } })),
        props.template &&
            props.template.type === TemplateType.SMS &&
            caseId &&
            collector && (React.createElement(PreviewInteraction, { versionId: props.template.versionId, interaction: {
                ...newInteraction,
                type: InteractionType.SMS,
                details: {
                    text: parseText(props.content, mentionSuggestions, PARSE_RESULT_TYPE.TEXT),
                    from: collector.nickname,
                    countryCode: '45',
                    number: '87654321',
                },
            } })),
        !caseId && (React.createElement("h3", { style: {
                margin: '4em 0',
                opacity: 0.7,
                textAlign: 'center',
            } }, lang.templates.selectTestCase))));
};
export default PreviewModal;
//# sourceMappingURL=PreviewModal.js.map